module.exports = __webpack_public_path__ + "static/media/logo-afl-fantasy.f01e9aab.svg";